<template>
  <main-layout>
    <h1 class="title">Crea prodotto</h1>
    <product-form
      :submit-action="create"
      :fields="fields"
      redirect-route="products.show"
    />
  </main-layout>
</template>

<script>
import { call } from "vuex-pathify"

import ProductForm from "@/components/ProductForm.vue"
import MainLayout from "@/layouts/Main.vue"

export default {
  components: {
    ProductForm,
    MainLayout
  },
  data() {
    return {
      loading: true
    }
  },
  methods: {
    create: call("products/create")
  }
}
</script>

<style lang="sass" scoped>
nav
  margin-top: 2.1rem
.column.is-narrow:first-child
  padding-left: 0
</style>
